import React, {useState} from 'react'
import {Navigate} from 'react-router-dom'
import home_ac from '../../../assets/Milidou/home-ac.png'
import home_inac from '../../../assets/Milidou/home-inac.png'
import comparaison_ac from '../../../assets/Milidou/comparaison-ac.png'
import comparaison_inac from '../../../assets/Milidou/comparaison-inac.png'
import traitement_ac from '../../../assets/Milidou/traitement-ac.png'
import traitement_inac from '../../../assets/Milidou/traitement-inac.png'
import parcelles_ac from '../../../assets/Milidou/parcelles-ac.png'
import parcelles_inac from '../../../assets/Milidou/parcelles-inac.png'

function FooterNavMildiou() {
    const [goToHome, setgoToHome] = useState(false)
    const [goToComp, setgoToComp] = useState(false)
    const [goToPDL, setgoToPDL] = useState(false)
    const [setgoToParcelles, setsetgoToParcelles] = useState(false)

    const url = window.location.href

    function handleClickHome() {
        setgoToHome(true)
        setgoToComp(false)
        setgoToPDL(false)
        setsetgoToParcelles(false)
    }
    function handleClickComp() {
        setgoToHome(false)
        setgoToComp(true)
        setgoToPDL(false)
        setsetgoToParcelles(false)
    }
    function handleClickPDL() {
        setgoToHome(false)
        setgoToComp(false)
        setgoToPDL(true)
        setsetgoToParcelles(false)
    }
    function handleClickParcelles() {
        setgoToHome(false)
        setgoToComp(false)
        setgoToPDL(false)
        setsetgoToParcelles(true)
    }

    if(goToHome) {
        return <Navigate push to={'/diagoriskMildiou/accueil'}/>
    }
    if(goToComp) {
        return <Navigate push to={'/diagoriskMildiou/menuComparaison'}/>
    }
    if(goToPDL) {
        return <Navigate push to={'/diagoriskMildiou/menu-plan-de-lutte'}/>
    }
    if(setgoToParcelles) {
        return <Navigate push to={'/diagoriskMildiou/mesParcelles'}/>
    }

    return (
        <div>
            <div className={'row menuOad menuOadMildiou backgroundMilidou'}>
                <button className={url.indexOf("diagoriskMildiou/accueil") > -1 ? 'ButtonMenuOADMilidouAC' : 'ButtonMenuOADMilidouINAC'} disabled={url.indexOf("diagoriskMildiou/accueil") > -1 ? true : false} onClick={handleClickHome}> 
                    <img src={url.indexOf("diagoriskMildiou/accueil") > -1 ? home_ac : home_inac}  alt='icone' className='IconMenuOAD'/> 
                    <div className={url.indexOf("diagoriskMildiou/accueil") > -1 ? 'nomMenuOAD nomMenuOADMildiouAC' : 'nomMenuOAD nomMenuOADMildiouINAC'}> Accueil </div>
                </button>
                <button className={url.indexOf("diagoriskMildiou/menuComparaison") > -1 ? 'ButtonMenuOADMilidouAC' : 'ButtonMenuOADMilidouINAC'}  disabled={url.indexOf("diagoriskMildiou/menuComparaison") > -1 ? true : false} onClick={handleClickComp}> 
                    <img src={url.indexOf("diagoriskMildiou/menuComparaison") > -1 ? comparaison_ac : comparaison_inac} alt='icone'  className='IconMenuOAD'/> 
                    <div className={url.indexOf("diagoriskMildiou/menuComparaison") > -1 ? 'nomMenuOAD nomMenuOADMildiouAC' : 'nomMenuOAD  nomMenuOADMildiouINAC'}>  Comparaison </div>
                </button>
                <button className={url.indexOf("diagoriskMildiou/menu-plan-de-lutte") > -1 ? 'ButtonMenuOADMilidouAC' : 'ButtonMenuOADMilidouINAC'} disabled={url.indexOf("diagoriskMildiou/menu-plan-de-lutte") > -1 ? true : false} onClick={handleClickPDL}> 
                    <img src={url.indexOf("diagoriskMildiou/menu-plan-de-lutte") > -1 ? traitement_ac : traitement_inac} alt='icone'  className='IconMenuOAD'/> 
                    <div className={url.indexOf("diagoriskMildiou/menu-plan-de-lutte") > -1 ? 'nomMenuOAD nomMenuOADMildiouAC' : 'nomMenuOAD nomMenuOADMildiouINAC'}> Plan de lutte </div>
                </button>
                <button className={url.indexOf("diagoriskMildiou/mesParcelles") > -1 ? 'ButtonMenuOADMilidouAC' : 'ButtonMenuOADMilidouINAC'} disabled={url.indexOf("diagoriskMildiou/mesParcelles") > -1 ? true : false} onClick={handleClickParcelles}> 
                    <img src={url.indexOf("diagoriskMildiou/mesParcelles") > -1 ? parcelles_ac : parcelles_inac} alt='icone'  className='IconMenuOAD'/> 
                    <div className={url.indexOf("diagoriskMildiou/mesParcelles") > -1 ? 'nomMenuOAD nomMenuOADMildiouAC' : 'nomMenuOAD nomMenuOADMildiouINAC'}> Vignoble </div>
                </button>
            </div>
        </div>
    )
}

export default FooterNavMildiou